var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4224_12438"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shield-check",
    width: 60,
    height: 60,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4224_12438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.5 30L27.5 35L37.5 25M50 30L50 20.54C50 18.54 50 17.54 49.67 16.68C49.38 15.92 48.91 15.25 48.3 14.71C47.61 14.1 46.67 13.75 44.8 13.05L31.4 8.02C30.88 7.83 30.62 7.73 30.35 7.69C30.12 7.66 29.87 7.66 29.64 7.69C29.37 7.73 29.11 7.83 28.59 8.02L15.19 13.05C13.32 13.75 12.38 14.1 11.69 14.71C11.08 15.25 10.61 15.92 10.32 16.68C10 17.54 10 18.54 10 20.54L10 30C10 41.15 23.65 49.23 28.39 51.7C28.91 51.97 29.16 52.1 29.52 52.17C29.8 52.23 30.19 52.23 30.47 52.17C30.83 52.1 31.08 51.97 31.6 51.7C36.34 49.23 50 41.15 50 30Z",
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.20d5e891f826d8b2773e1729c8d815fe.svg";
export { ForwardRef as ReactComponent };